import Vue from 'vue'

import mm_ss from './mm_ss'
import clear_string from './clear_string'

Vue.filter('mm_ss', mm_ss); // приводим милисекунды к строке вида 30:00
Vue.filter('clear_string', clear_string); // очищаем строку от всех спец символов и пробелов